import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { Snackbar, Alert, CircularProgress, Button, Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Select, MenuItem, TextField } from '@mui/material';


function TransformationComponent({ data,nodeId,updateTransformNodeData }) {
  
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'info',
  });
  // State for storing user selections
  const createInitialUserInput = (rowsData) => {
    if (rowsData && rowsData.length > 0) {
      return rowsData[0].map(cell => ({
        operator: "None",
        value: "",
        column: cell !== null && cell !== undefined ? cell : "-",
      }));
    }
    return [];
  };
  
  // Within your component:
  const [rows, setRows] = useState(data && Array.isArray(data.values) ? data.values : []);
  const [userInput, setUserInput] = useState(createInitialUserInput(rows));
  useEffect(() => {
    setUserInput(createInitialUserInput(rows));
  }, [rows]);

  useEffect(() => {
    console.log(rows); // this will log the updated value of rows whenever it changes
}, [rows]);

  const handleInputChange = (index, field) => (event) => {
    console.log(index, field, event.target.value)
    const newUserInput = [...userInput];
    newUserInput[index][field] = event.target.value;
    setUserInput(newUserInput);
  };

  const handleSendData = () => {
    setIsLoading(true); // Start loading indicator
    const requestBody = {
      userInput: userInput,
      completeData: data
    };

    fetch(`${process.env.REACT_APP_BACK_END_URL}/workflow/transform`, {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      setSnackbar({ open: true, message: 'Transformation succeeded', severity: 'success' });
      console.log("inside data values : ", data.transformedData.values)
      setRows(data.transformedData.values); 
      updateTransformNodeData(nodeId, data.transformedData);
    })
    .catch(error => {
      console.error('There was a problem with the fetch operation:', error);
      setSnackbar({ open: true, message: 'Transformation failed', severity: 'error' });
    })
    .finally(() => {
      setIsLoading(false);
    });
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };


  return (
    <>
    {isLoading && (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress style={{color:'white'}}/>
        </Box>
      )}
    <Typography variant="h5" style={{ color:'white' }}>
    Transform Data
  </Typography>
  <Typography variant="subtitle1" style={{color:'white'}}>
    Data Columns
  </Typography>
    <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
          }}
        >
     
      {rows.length > 0 && rows[0] ? (
        <TableContainer component={Paper}>
          <Table size="small" aria-label="fetched data table">
            <TableBody>
              {rows[0].map((cell, cellIndex) => (
                <TableRow key={cellIndex}>
                  <TableCell style={{ color: theme.palette.black[100] }}>
                    {cell !== null && cell !== undefined ? cell : "-"}
                  </TableCell>
                  <TableCell>
                    <Select
                      value={userInput[cellIndex].operator}
                      onChange={handleInputChange(cellIndex, "operator")}
                      style={{ color: theme.palette.black[100] }}
                    >
                      <MenuItem value="None" style={{ color: theme.palette.black[100] }}>Operator</MenuItem>
                      <MenuItem value="+" style={{ color: theme.palette.black[100] }}>+</MenuItem>
                      <MenuItem value="-" style={{ color: theme.palette.black[100] }}>-</MenuItem>
                      <MenuItem value="/" style={{ color: theme.palette.black[100] }}>/</MenuItem>
                      <MenuItem value="*" style={{ color: theme.palette.black[100] }}>*</MenuItem>
                    </Select>
                  </TableCell>
                  <TableCell>
                    <TextField
                      value={userInput[cellIndex].value}
                      onChange={handleInputChange(cellIndex, "value")}
                      inputProps={{ style: { color: 'black' } }}
                    />

                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : null}
      <Button
            onClick={handleSendData}
            style={{ backgroundColor: 'white', color: 'black', marginTop: '10px' }}
            variant="contained"
          >
            Transform Data
          </Button>
    </Box>
    
    <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={handleCloseSnackbar}>
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default TransformationComponent;
